// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IHealthPolicyDeductibleDto } from './IHealthPolicyDeductibleDto';
import {
    IHealthPolicyDeductibleDtoFromJSON,
    IHealthPolicyDeductibleDtoFromJSONTyped,
    IHealthPolicyDeductibleDtoToJSON,
    IHealthPolicyDeductibleDtoToJSONTyped,
} from './IHealthPolicyDeductibleDto';

/**
 * 
 * @export
 * @interface IHealthPolicyDto
 */
export interface IHealthPolicyDto {
    /**
     * 
     * @type {number}
     * @memberof IHealthPolicyDto
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof IHealthPolicyDto
     */
    health_plan_id?: number;
    /**
     * 
     * @type {number}
     * @memberof IHealthPolicyDto
     */
    employee_id?: number;
    /**
     * 
     * @type {Set<IHealthPolicyDeductibleDto>}
     * @memberof IHealthPolicyDto
     */
    deductibles?: Set<IHealthPolicyDeductibleDto>;
    /**
     * 
     * @type {number}
     * @memberof IHealthPolicyDto
     */
    current_coverage_id?: number;
}

/**
 * Check if a given object implements the IHealthPolicyDto interface.
 */
export function instanceOfIHealthPolicyDto(value: object): value is IHealthPolicyDto {
    return true;
}

export function IHealthPolicyDtoFromJSON(json: any): IHealthPolicyDto {
    return IHealthPolicyDtoFromJSONTyped(json, false);
}

export function IHealthPolicyDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IHealthPolicyDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'health_plan_id': json['health_plan_id'] == null ? undefined : json['health_plan_id'],
        'employee_id': json['employee_id'] == null ? undefined : json['employee_id'],
        'deductibles': json['deductibles'] == null ? undefined : (new Set((json['deductibles'] as Array<any>).map(IHealthPolicyDeductibleDtoFromJSON))),
        'current_coverage_id': json['current_coverage_id'] == null ? undefined : json['current_coverage_id'],
    };
}

export function IHealthPolicyDtoToJSON(json: any): IHealthPolicyDto {
    return IHealthPolicyDtoToJSONTyped(json, false);
}

export function IHealthPolicyDtoToJSONTyped(value?: IHealthPolicyDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'health_plan_id': value['health_plan_id'],
        'employee_id': value['employee_id'],
        'deductibles': value['deductibles'] == null ? undefined : (Array.from(value['deductibles'] as Set<any>).map(IHealthPolicyDeductibleDtoToJSON)),
        'current_coverage_id': value['current_coverage_id'],
    };
}

